import { ShieldCheck } from "lucide-react";

const ROLES = [
  { rol: "Süper Admin", kisi: 1, yetki: "Tüm yetkiler", renk: "#F0651E" },
  { rol: "Finans Yöneticisi", kisi: 3, yetki: "Kasa, Rapor, Havale", renk: "#7A2FBE" },
  { rol: "Saha Sorumlusu", kisi: 6, yetki: "Saha Hesapları, Ekipler", renk: "#1E7A5E" },
  { rol: "Destek Ekibi", kisi: 9, yetki: "Kullanıcılar, Hazır Cevaplar", renk: "#F0813E" },
  { rol: "İzleyici", kisi: 4, yetki: "Sadece görüntüleme", renk: "#78C043" },
];

export default function Yetkiler() {
  return (
    <div className="space-y-5" data-testid="page-yetkiler">
      <div className="flex items-center gap-2.5">
        <div className="w-10 h-10 rounded-xl bg-orange-100 dark:bg-orange-900/30 flex items-center justify-center">
          <ShieldCheck className="text-[#F0651E]" size={22} />
        </div>
        <div>
          <h1 className="text-xl font-extrabold">Yetkiler & Roller</h1>
          <p className="text-xs text-slate-500">Kullanıcı rolleri ve erişim yetkileri</p>
        </div>
      </div>

      <div className="bg-white dark:bg-[#151824] rounded-2xl shadow-sm border border-slate-100 dark:border-slate-800 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-[13px] font-bold text-violet-600 dark:text-violet-400 border-b border-slate-100 dark:border-slate-800">
                <th className="px-6 py-3">ROL</th>
                <th className="px-4 py-3 text-right">KİŞİ</th>
                <th className="px-4 py-3">YETKİLER</th>
                <th className="px-6 py-3">DURUM</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100 dark:divide-slate-800">
              {ROLES.map((r) => (
                <tr key={r.rol} className="hover:bg-slate-50 dark:hover:bg-slate-800/50">
                  <td className="px-6 py-3 font-bold flex items-center gap-2"><span className="w-2.5 h-2.5 rounded-full" style={{ background: r.renk }} />{r.rol}</td>
                  <td className="px-4 py-3 text-right font-semibold">{r.kisi}</td>
                  <td className="px-4 py-3 text-slate-500">{r.yetki}</td>
                  <td className="px-6 py-3"><span className="px-2.5 py-1 rounded-full text-xs font-semibold bg-green-100 text-green-700 dark:bg-green-900/40 dark:text-green-300">Aktif</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
